import axios from 'axios';

/**
 * Public axios instance for unauthenticated API calls
 *
 * Used for endpoints that don't require a Bearer token (e.g. user registration).
 * No request or response interceptors are attached — no MSAL token acquisition,
 * no 401 retry, no session-expired redirect.
 *
 * The APIM subscription key is still required by API Management for routing.
 */
export const publicAxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_WEBAPI_DOTNET_URI,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    ...(import.meta.env.VITE_SUBSCRIPTION_KEY
      ? { 'Ocp-Apim-Subscription-Key': import.meta.env.VITE_SUBSCRIPTION_KEY }
      : {}),
  },
});
